










































































import { Vue, Component, Prop, Watch, Provide } from "vue-property-decorator";
import { getCookie } from "@szgc/plt-core-v2";
import Api from "../../api/index";
import request from "../../api/request";
import MinePage from "./mine/index.vue";
import TodoPage from "./todos/index.vue";
import DonePage from "./dones/index.vue";
import WaitPage from "./tosend/index.vue";
import SendPage from "./send/index.vue";
import FinePage from "./finish/index.vue";
import TermPage from "./term/index.vue";
import CopyPage from "./copy/index.vue";

const MinePageComponent = MinePage as any;
const TodoPageComponent = TodoPage as any;
const DonePageComponent = DonePage as any;
const WaitPageComponent = WaitPage as any;
const SendPageComponent = SendPage as any;
const FinePageComponent = FinePage as any;
const TermPageComponent = TermPage as any;
const CopyPageComponent = CopyPage as any;

@Component({
  name: "SzgcMobileGetor",
  components: {
    MinePage: MinePageComponent,
    TodoPage: TodoPageComponent,
    DonePage: DonePageComponent,
    WaitPage: WaitPageComponent,
    SendPage: SendPageComponent,
    FinePage: FinePageComponent,
    TermPage: TermPageComponent,
    CopyPage: CopyPageComponent
  }
})
export default class SzgcMobileGetor extends Vue {
  @Provide()
  private client = "mobile";

  @Prop({ required: true })
  page!: string;

  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private topShow!: boolean;

  @Prop({
    type: [String, Number],
    default: "all"
  })
  private logType!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  private viewRead!: boolean;

  private showPage: boolean = false;
  private flowInfo: any = null;
  private childData: any = null;
  private formData: any = {
    businessName: ""
  };
  private prefix: string = "";

  @Watch("dataAll", { immediate: true, deep: true })
  private async getData(newVal: any) {
    this.showPage = false;
    this.prefix = getCookie("plt-api-route") || "";
    this.flowInfo = JSON.parse(JSON.stringify(newVal));
    if (newVal) {
      if (this.page === "mine") {
        await this.flowInitRead();
      }
      if (this.page === "todo") {
        await this.getTodoSingle();
      }
      if (this.page === "done") {
        await this.getDoneSingle();
      }
      if (this.page === "wait") {
        await this.getToSendSingle();
      }
      if (this.page === "sent") {
        await this.getSendSingle();
      }
      if (this.page === "fine") {
        await this.getFineSingle();
      }
      if (this.page === "term") {
        await this.getTermSingle();
      }
      if (this.page === "cc") {
        await this.getCopySingle();
      }
    }
  }

  /*操作成功事件*/
  dealSuccess(data: any) {
    if (this.page === "mine" || this.page === "wait") {
      this.$emit("childEvt", { page: this.page, formData: this.formData, ...data });
    } else if (
      this.page === "sent" ||
      this.page === "fine" ||
      this.page === "term" ||
      this.page === "cc"
    ) {
      this.$emit("childEvt", { page: this.page, formData: this.formData });
    } else if (this.page === "todo" || this.page === "done") {
      this.$emit("childEvt", { page: this.page, formData: this.formData, type: data.type });
    }
  }

  /*获取初始流程数据*/
  async flowInitRead() {
    const params = {
      clientType: "web",
      flowCfgId: this.flowInfo.businessId
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.flowInitRead(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取初始流程数据失败:" + message);
        return false;
      }
      if (data) {
        this.formData = data;
        this.$nextTick(() => {
          this.showPage = true;
        });
      } else {
        this.showPage = false;
        this.$message.info("数据已失效");
      }
    } catch (error: any) {
      this.$message.error("获取初始流程数据失败:" + error);
    }
  }

  /*获取我的待办事项单条查询结果*/
  async getTodoSingle() {
    const params = {
      status: this.flowInfo.status,
      businessId: this.flowInfo.businessId,
      clientType: "web",
      procTaskId: this.flowInfo.taskId
    };
    this.$nextTick(() => {
      this.childData = params;
      this.showPage = true;
    });
  }

  /*获取我的已办事项单条查询结果*/
  async getDoneSingle() {
    const params = {
      status: this.flowInfo.status,
      businessId: this.flowInfo.businessId,
      clientType: "web",
      procTaskId: this.flowInfo.taskId
    };
    this.$nextTick(() => {
      this.childData = params;
      this.showPage = true;
    });
  }

  /*获取我的待发事项单条查询结果*/
  async getToSendSingle() {
    const params = {
      businessId: this.flowInfo.businessId,
      clientType: "web"
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getToSendSingle(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取待发流程数据失败:" + message);
        return false;
      }
      if (data) {
        this.childData = data;
        this.formData = data;
        this.showPage = true;
      } else {
        this.showPage = false;
        this.$message.info("数据已失效");
      }
    } catch (error: any) {
      this.$message.error("获取待发流程数据失败:" + error);
    }
  }

  /*获取我的已发事项单条查询结果*/
  async getSendSingle() {
    const params = {
      businessId: this.flowInfo.businessId,
      status: this.flowInfo.status
    };
    this.$nextTick(() => {
      this.childData = params;
      this.showPage = true;
    });
  }

  /*获取我的办结事项单条查询结果*/
  async getFineSingle() {
    const params = {
      businessId: this.flowInfo.businessId
    };
    this.$nextTick(() => {
      this.childData = params;
      this.showPage = true;
    });
  }

  /*获取我的终结事项单条查询结果*/
  async getTermSingle() {
    const params = {
      businessId: this.flowInfo.businessId
    };
    this.$nextTick(() => {
      this.childData = params;
      this.showPage = true;
    });
  }

  /*获取我的抄送事项单条查询结果*/
  async getCopySingle() {
    const params = {
      businessId: this.flowInfo.businessId
    };
    this.$nextTick(() => {
      this.childData = params;
      this.showPage = true;
    });
  }
}
